module.exports = __webpack_public_path__ + "img/souqbox.e311ae7f.gif";